import { ReactNode } from 'react';

import styles from './AnimatedArrowPair.module.scss';

type Props = {
  iconIn: ReactNode;
  iconOut: ReactNode;
  className?: string;
};

export const AnimatedArrowPair = ({ iconIn, iconOut, className }: Props) => {
  return (
    <span className={`${styles.wrapper} ${className}`}>
      <span className={styles.base}>{iconIn}</span>
      <span className={styles.hover}>{iconOut}</span>
    </span>
  );
};
